import { useMemo, useState } from "react";
import { fr, num } from "../content/fr";
import { Reveal } from "./ui-bits";

export default function RoiCalculator() {
  const [videosJour, setVideosJour] = useState(3);
  const [canaux, setCanaux] = useState(3);
  const [jours, setJours] = useState(22);

  const total = useMemo(() => {
    const v = Math.max(0, Math.round(Number(videosJour) * Number(canaux) * Number(jours)));
    return isNaN(v) ? 0 : v;
  }, [videosJour, canaux, jours]);

  const f = fr.roi.fields;
  return (
    <section className="section" data-testid="roi-section">
      <div className="container">
        <Reveal className="block-head">
          <span className="eyebrow"><span className="sq" />{fr.roi.eyebrow}</span>
          <h2 className="h2">{fr.roi.title}</h2>
        </Reveal>
        <div className="roi-wrap">
          <div className="glass card">
            <div className="roi-fields">
              <div className="field">
                <label htmlFor="roi-vj">{f.videosJour}</label>
                <input id="roi-vj" type="number" min="0" className="tnum" value={videosJour} onChange={(e) => setVideosJour(e.target.value)} data-testid="roi-videos" />
              </div>
              <div className="field">
                <label htmlFor="roi-can">{f.canaux}</label>
                <input id="roi-can" type="number" min="0" className="tnum" value={canaux} onChange={(e) => setCanaux(e.target.value)} data-testid="roi-canaux" />
              </div>
              <div className="field">
                <label htmlFor="roi-j">{f.jours}</label>
                <input id="roi-j" type="number" min="0" className="tnum" value={jours} onChange={(e) => setJours(e.target.value)} data-testid="roi-jours" />
              </div>
            </div>
            <p className="muted" style={{ fontSize: "0.8rem", marginTop: "1.2rem" }}>{fr.roi.disclaimer}</p>
          </div>
          <div className="glass roi-result">
            <span className="eyebrow" style={{ marginBottom: "0.5rem" }}>{fr.roi.result}</span>
            <div className="value tnum" data-testid="roi-result">{num(total)}</div>
          </div>
        </div>
      </div>
    </section>
  );
}
